import React from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import Rupee from 'views/Rupee';
import { getFullName } from 'config/utils';
import ConvenienceFeesAccordion from '../convenience-fee/ConvenienceFeesAccordion';

const LinksConvenienceFeesAccordion = ({
  amount,
}) => (
  <div className="text-medium">
    <span>Amount</span>
    <span className="right"><Rupee value={amount} /></span>
    <ConvenienceFeesAccordion />
  </div>
);

const LinksMerchantHeader = ({
  sellerAvatar, seller, title, totalAmountFormatted, showDeferred,
  showConvenienceFee, showConvenienceFeeOnRetry, isAwaitingPaymentCompletion,
  isInstapayPayment, onChangeInstapayForm, ...props
}) =>
  <div className={classNames('payments-header', sellerAvatar ? 'has--avatar' : null)}>
    <div className="soft" style={{ background: '#F3F6FA', borderRadius: '4px 4px 0 0' }}>
      <div className="media">
        <div className="media__img payments-header--avatar-container">
          <img
            className="payments-header--avatar"
            height={40} width={40}
            alt={getFullName(seller)}
            src={showDeferred ? sellerAvatar : null}
            />
        </div>
        <div className="media__body">
          <p className="flush--bottom text-payments-grey">Paying to</p>
          <div className="flush--bottom">{getFullName(seller)}</div>
        </div>
      </div>
    </div>
    { title && totalAmountFormatted && !props.isEditing ?
      <div className="soft--sides soft--top" style={{ background: '#fff' }}>
        <p className="flush--bottom text-payments-grey">
          Purpose of Payment
          { isInstapayPayment && !props.isRAP && !isAwaitingPaymentCompletion ?
            <a
              className="right"
              style={{ fontSize: '16px' }}
              onClick={() => onChangeInstapayForm()}>Change</a> :
            null
          }
        </p>
        <p className="push--bottom break-long-words">{title}</p>
        { showConvenienceFee ?
          <LinksConvenienceFeesAccordion
            amount={totalAmountFormatted} /> :
          <div>
            <p className="flush--bottom text-payments-grey">Amount</p>
            <p className="flush--bottom">
              <Rupee value={totalAmountFormatted} />
            </p>
          </div>
        }
      </div> :
      null
    }
    { showConvenienceFeeOnRetry ?
      <div className="soft--sides soft--top background-white">
        <LinksConvenienceFeesAccordion amount={totalAmountFormatted} />
      </div> :
      null
    }
  </div>;

  const mapStateToProps = ({
    settings: {
      showConvenienceFee,
      isRetrying,
      isAwaitingPaymentCompletion,
    },
    retry,
  }) => ({
    showConvenienceFeeOnRetry: isRetrying && showConvenienceFee && retry.finalizePurchase.selectedPaymentMode,
    showConvenienceFee,
    isAwaitingPaymentCompletion,
  });

export default connect(mapStateToProps)(LinksMerchantHeader);



// WEBPACK FOOTER //
// ./src/payments/views/links/LinksMerchantHeader.js